import { useEffect, useReducer } from 'react'
import { ChargerContext, useMapState } from './context'
import { chargersReducer, initialChargerState } from './reducers'
import { useParams } from 'react-router-dom'
import {
	resetActiveChargerState,
	updateLoadMap,
} from './actions'

export default function ChargerStateProvider({ children, logIt = false }) {
	const [state, dispatch] = useReducer(chargersReducer, initialChargerState)
	const [, mapDispatch] = useMapState()
	const { id } = useParams()

	useEffect(
		() => logIt && console.log('ChargerStateProvider', state),
		[logIt, state]
	)

	useEffect(() => {
		if (!id) mapDispatch(updateLoadMap(true)) // trigger a map load when there is no id
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id])

	useEffect(() => {
		// if there is no id but there is a saved view that means the user pressed the back button instead of the "Browse Chargers" button
		// so we fly to the saved view
		if (!id) {
			dispatch(resetActiveChargerState())
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id])

	return (
		<ChargerContext.Provider value={[state, dispatch]}>
			{children}
		</ChargerContext.Provider>
	)
}
